import { Button, Flex, TextInput } from "@mantine/core";
import { useState } from "react";
import { toast } from "react-hot-toast";
import { getGeoCodeFromAddress } from "@/utils/helpers";

export default function AddressFinder({
  title,
  setAddress,
  setLat,
  setLng,
  address,
  noLabel = false,
}) {
  const [addressInput, setAddressInput] = useState("");

  async function handleSubmit() {
    const res = await getGeoCodeFromAddress(addressInput);
    if (res.lat && res.lng) {
      toast.success("주소를 찾았습니다");
      setAddress(res.address);
      setLat(res.lat);
      setLng(res.lng);
    } else {
      toast.error("주소를 찾을 수 없습니다.");
    }
  }

  return (
    <Flex gap="xs">
      {address ? (
        <>
          <TextInput mb={0} sx={{ flex: 4 }} disabled readOnly label={title} value={address} />
          <Button sx={{ flex: 1 }} mt={"xl"} onClick={() => setAddress("")} color="red">
            다시 입력
          </Button>
        </>
      ) : (
        <>
          <TextInput
            sx={{ flex: 4 }}
            placeholder={title + " 입력"}
            label={title}
            required
            value={addressInput}
            onChange={(e) => setAddressInput(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && addressInput) {
                // prevent form submission
                e.preventDefault();
                handleSubmit();
              }
            }}
          />
          <Button sx={{ flex: 1 }} mt={"xl"} onClick={handleSubmit} disabled={!addressInput}>
            검색
          </Button>
        </>
      )}
    </Flex>
  );
}
